import React from 'react';
import PropTypes from 'prop-types';
import { t } from '@cyberint/common-utils';
import { CopyableTitle, B1C, LoadingOverlay } from '@cyberint/dsc';
import * as S from './styled';

export const Messages = ({ messages, isLoading }) => (
  <S.MessagesWrapper $isError={messages?.some(m => !!m.error)}>
    {isLoading && (
      <S.LoaderWrapper>
        <LoadingOverlay />
      </S.LoaderWrapper>
    )}

    {messages?.map(m => (
      <S.SingleMsg>
        {m.corId || m.reqId || m.error ? (
          <CopyableTitle
            key={m.origError || m.error}
            copyTooltipText={t('infinity_auth.error_copied')}
            title={m.error}
            valueToCopy={`correlation_id: "${m.corId}" AND request_id: "${m.reqId}" OR message: "${m.origError}"`}
          />
        ) : (
          <B1C key={m} className="message-step">
            {m}
          </B1C>
        )}
      </S.SingleMsg>
    ))}
  </S.MessagesWrapper>
);

Messages.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.node),
  isLoading: PropTypes.bool
};
